import { AxiosInstance } from 'axios';
import {
  BulkOrderServicesEndpoint,
  BulkOrdersRequest,
  BulkTendersRequest,
} from './BulkOrderServices.types';

export class BulkOrderServices implements BulkOrderServicesEndpoint {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  exportBills(body: BulkOrdersRequest) {
    return this.instance.put('/bulk/order/bill/export', body);
  }

  exportInvoices(body: BulkOrdersRequest) {
    return this.instance.put('/bulk/order/invoice/export', body);
  }

  acceptTenders(request: BulkTendersRequest) {
    return this.instance.put('/bulk/tender/accept', request.body);
  }

  rejectTenders(request: BulkTendersRequest) {
    return this.instance.put('/bulk/tender/reject', request.body);
  }
}
